import "../assets/scss/Filter.scss";

import { observer } from "mobx-react";
import * as React from "react";
import { NavLink } from "react-router-dom";

import { ILoanWordsStore, NullWordFilter, WordFilter } from "../stores/word/LoanWordsStore";
import { ButtonAndBadge } from "./ButtonAndBadge";

import ReactDOM = require("react-dom");

export interface FilterProps {
  filter: WordFilter;
  includeHeader: boolean;
  wordStore: ILoanWordsStore;
}

@observer
export class Filter extends React.Component<FilterProps, undefined> {
  render() {
    return this.renderLanguages();
  }

  private renderLanguages(): JSX.Element {
    const emptyFilter = new NullWordFilter();

    const filterLanguage = this.props.filter.originalLanguage;
    // default to All:
    let activeKey = 0;
    if (filterLanguage) {
      activeKey =
        this.props.wordStore.getLanguages(emptyFilter).indexOf(filterLanguage) +
        1;
    }

    const wellStyles = {
      maxWidth: 400,
      margin: "0 auto",
      height: "100%"
    };

    const languagesContainerCss = this.props.includeHeader
      ? "filter_languagesContainer"
      : "filter_languagesContainer_portrait";

    return (
      <div className="well" style={wellStyles}>
        {this.props.includeHeader && (
          <div className="pageHeaderContainer">
            <h1 className="pageHeader">Loan Words</h1>
          </div>
        )}
        <div className={languagesContainerCss}>
          <NavLink to={"/"} class="allLink">
            <ButtonAndBadge
              isActive={activeKey === 0}
              text="All languages"
              count={this.props.wordStore.getWordCount()}
              ref={activeKey === 0 ? this.bindActiveButton : undefined}
            />
          </NavLink>
          {this.props.wordStore
            .getLanguages(emptyFilter)
            .map((language, index) => {
              const isActive = activeKey === index + 1;
              return (
                <NavLink to={"/filter/" + language} className="routerLink">
                  <ButtonAndBadge
                    isActive={isActive}
                    text={language}
                    count={this.props.wordStore.getWordCountForLanguage(
                      language
                    )}
                    ref={isActive ? this.bindActiveButton : undefined}
                  />
                </NavLink>
              );
            })}
        </div>
      </div>
    );
  }

  private bindActiveButton = (element: ButtonAndBadge) => {
    const node = ReactDOM.findDOMNode(element) as HTMLElement;
    if (node) {
      node.scrollIntoView();
    }
  };
}



// WEBPACK FOOTER //
// ./components/Filter.tsx